module.exports = __webpack_public_path__ + "resources/img/appcelerator.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/appcelerator.png
// module id = 1101
// module chunks = 0